import { render, staticRenderFns } from "./LegacyReports.vue?vue&type=template&id=1f26254a&scoped=true&"
import script from "./LegacyReports.vue?vue&type=script&lang=ts&"
export * from "./LegacyReports.vue?vue&type=script&lang=ts&"
import style0 from "./LegacyReports.vue?vue&type=style&index=0&id=1f26254a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26254a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
